export const matchDemoRoute = (method, path) => {
    const httpMethod = String(method || 'get').toLowerCase()
    const apiPath = String(path || '').replace(/^\//, '').replace(/\/$/, '')

    if (apiPath === 'fabricante' && httpMethod === 'get') return 'fabricantes'
    if (/^fabricante\/\d+\/modelo$/.test(apiPath) && httpMethod === 'get') return 'modelos'
    if (apiPath === 'operadora' && httpMethod === 'get') return 'operadoras'
    if (apiPath === 'configuracao-timezone' && httpMethod === 'get') return 'timezones'
    if (apiPath === 'acesso/tipo' && httpMethod === 'get') return 'tipoAcessos'
    if (apiPath === 'monitorado-tipo' && httpMethod === 'get') return 'monitoradoTipos'
    if (apiPath === 'monitorado/tipo' && httpMethod === 'get') return 'monitoradoTiposPaginated'
    if (apiPath === 'permissoes-cliente' && httpMethod === 'get') return 'permissoes'
    if (apiPath.startsWith('acesso/modulo') && httpMethod === 'get') return 'modulos'

    if (apiPath === 'equipamento' && httpMethod === 'get') return 'listEquipamentos'
    if (apiPath === 'equipamento' && httpMethod === 'post') return 'createEquipamento'
    if (/^equipamento\/\d+$/.test(apiPath) && httpMethod === 'get') return 'getEquipamento'
    if (/^equipamento\/\d+$/.test(apiPath) && (httpMethod === 'patch' || httpMethod === 'put')) {
        return 'updateEquipamento'
    }
    if (/^equipamento\/\d+\/historico$/.test(apiPath) && httpMethod === 'get') return 'historico'
    if (
        apiPath.startsWith('equipamento/') &&
        apiPath.includes('gateway') &&
        httpMethod === 'get'
    ) {
        return 'listEquipamentos'
    }

    if (apiPath.startsWith('campo-customizado') && httpMethod === 'get') return 'listCampos'
    if (apiPath === 'campo-customizado' && httpMethod === 'post') return 'createCampo'
    if (
        /^campo-customizado\/\d+$/.test(apiPath) &&
        (httpMethod === 'patch' || httpMethod === 'put')
    ) {
        return 'updateCampo'
    }

    if (apiPath === 'cliente/perfil' && httpMethod === 'get') return 'listPerfis'
    if (apiPath === 'cliente/perfil' && httpMethod === 'post') return 'createPerfil'
    if (/^cliente\/perfil\/\d+$/.test(apiPath) && httpMethod === 'get') return 'getPerfil'
    if (
        /^cliente\/perfil\/\d+$/.test(apiPath) &&
        (httpMethod === 'patch' || httpMethod === 'put')
    ) {
        return 'updatePerfil'
    }

    if (apiPath.startsWith('confirmacao-email')) return 'emailConfirmacao'

    if (apiPath === 'cliente' && httpMethod === 'get') return 'listClientes'
    if (apiPath === 'cliente' && httpMethod === 'post') return 'createCliente'
    if (/^cliente\/\d+$/.test(apiPath) && httpMethod === 'get') return 'getCliente'
    if (/^cliente\/\d+$/.test(apiPath) && (httpMethod === 'patch' || httpMethod === 'put')) {
        return 'updateCliente'
    }
    if (/^cliente\/\d+\/endereco$/.test(apiPath) && httpMethod === 'get') return 'emptyList'
    if (/^cliente\/\d+\/contato$/.test(apiPath) && httpMethod === 'get') return 'emptyList'

    if (apiPath === 'monitorado' && httpMethod === 'get') return 'listMonitoradosGrid'
    if (apiPath === 'monitorado' && httpMethod === 'post') return 'createMonitorado'
    if (/^monitorado\/\d+$/.test(apiPath) && httpMethod === 'get') return 'getMonitorado'
    if (/^monitorado\/\d+$/.test(apiPath) && (httpMethod === 'patch' || httpMethod === 'put')) {
        return 'updateMonitorado'
    }

    if (apiPath.startsWith('monitorado-parametro') && httpMethod === 'get') {
        return 'listMonitoradoParametros'
    }
    if (apiPath === 'monitorado-parametro' && httpMethod === 'post') return 'linkParametro'
    if (/^monitorado-parametro\/\d+$/.test(apiPath) && httpMethod === 'delete') {
        return 'unlinkParametro'
    }
    if (apiPath.startsWith('monitorado-comando') && httpMethod === 'get') return 'emptyList'
    if (apiPath.startsWith('monitorado-foto') && httpMethod === 'get') return 'emptyList'

    if (apiPath.startsWith('lista-monitorado') && httpMethod === 'get') return 'listaMonitorados'
    if (apiPath === 'dados-dashboard' && httpMethod === 'get') return 'dadosDashboard'
    if (apiPath.startsWith('observacao') && httpMethod === 'get') return 'emptyList'
    if (/^monitorado-status\/\d+$/.test(apiPath) && httpMethod === 'get') return 'monitoradoStatus'
    if (apiPath === 'monitorado-status-grafico' && httpMethod === 'post') return 'statusGrafico'
    if (apiPath === 'reporte/consumo' && httpMethod === 'post') return 'consumo'
    if (apiPath.startsWith('monitorado-status-reportes') && httpMethod === 'post') {
        return 'statusReportes'
    }

    if (apiPath.startsWith('supervisorio/historico') && httpMethod === 'post') {
        return 'supervisorioHistorico'
    }
    if (
        apiPath.startsWith('supervisorio') &&
        !apiPath.includes('historico') &&
        httpMethod === 'get'
    ) {
        return 'listSupervisorios'
    }
    if (
        /^supervisorio\/\d+$/.test(apiPath) &&
        (httpMethod === 'patch' || httpMethod === 'put')
    ) {
        return 'updateSupervisorio'
    }
    if (apiPath === 'reporte/supervisorio' && httpMethod === 'post') return 'reporteSupervisorio'
    if (apiPath === 'comando-customizado' && httpMethod === 'get') return 'emptyList'
    if (apiPath.startsWith('comando-customizado') && httpMethod === 'get') return 'emptyList'

    if (apiPath.includes('formulas_check') || /execute-api\.amazonaws\.com/.test(apiPath)) {
        return 'formulaCheck'
    }
    if (apiPath.startsWith('formula-template') && httpMethod === 'get') return 'formulaTemplates'

    return null
}

export const extractEmpresaApiPath = (url) => {
    const rawUrl = String(url || '')
    if (rawUrl.includes('formulas_check') || rawUrl.includes('execute-api.amazonaws.com')) {
        return 'formulas_check'
    }

    const pathMatch = rawUrl.match(/\/v2\/[^/?]+\/([^?#]*)/)
    if (!pathMatch) return null
    return pathMatch[1]
}
